import * as React from 'react';

import { DimeCardColumns } from '../DimeCardColumns.js';
import { DimeCardShell } from '../DimeCardShell.js';
import {
  DimeTabCount,
  DimeTabs,
  DimeTabsContent,
  DimeTabsList,
  DimeTabsTrigger,
} from '../DimeTabs.js';
import { DETAILS_TAB } from '../lib/detail-layout-details-tab.js';
import type { DimeDetailLayoutHeader, DimeDetailLayoutTab } from './DimeDetailLayout.types.js';

type DimeDetailLayoutRecordProps = Readonly<{
  header: DimeDetailLayoutHeader;
  tabs: DimeDetailLayoutTab[];
  currentTab: string | undefined;
  onTabChange: (value: string) => void;
  renderTab: (value: string) => React.ReactNode;
  cards: React.ReactNode;
  isMobile: boolean;
}>;

export function DimeDetailLayoutRecord({
  header,
  tabs,
  currentTab,
  onTabChange,
  renderTab,
  cards,
  isMobile,
}: DimeDetailLayoutRecordProps) {
  return (
    <div className="flex h-full min-w-0 flex-col">
      <div className="p-4">
        <DimeCardShell headingLevel={1} {...header} />
      </div>
      <DimeTabs value={currentTab} onValueChange={onTabChange} className="min-h-0 flex-1 gap-0">
        {/* The line variant's underline hangs 5px below the list, so the scroller leaves room for it. */}
        <div className="no-scrollbar scroll-fade-x -mb-1.25 shrink-0 overflow-x-auto overflow-y-hidden pb-1.25">
          <DimeTabsList variant="line" className="px-4">
            {tabs.map((tab) => (
              <DimeTabsTrigger key={tab.value} value={tab.value}>
                {tab.label}
                {tab.count === undefined ? null : <DimeTabCount>{tab.count}</DimeTabCount>}
              </DimeTabsTrigger>
            ))}
          </DimeTabsList>
        </div>
        {currentTab === undefined ? null : (
          <DimeTabsContent value={currentTab} className="min-h-0 flex-1 overflow-auto p-4">
            {currentTab === DETAILS_TAB ? (
              <DimeCardColumns maxColumns={isMobile ? 1 : 4}>{cards}</DimeCardColumns>
            ) : (
              renderTab(currentTab)
            )}
          </DimeTabsContent>
        )}
      </DimeTabs>
    </div>
  );
}
